import { Box } from '@chakra-ui/react';
import { useMemo } from 'react';
import { ParagraphInfoBoxFragment } from '../../../generated/types';
import { HTMLText } from '../../Common/HTMLText';

interface InfoBoxProps {
  data: ParagraphInfoBoxFragment;
}

export const InfoBox: React.FC<InfoBoxProps> = ({ data }) => {
  const color = useMemo(() => {
    if (data.colorSchema === 'red') {
      return {
        bg: '#ffe3e3',
      };
    } else if (data.colorSchema === 'green') {
      return {
        bg: '#d3f9d8',
      };
    } else if (data.colorSchema === 'blue') {
      return {
        bg: '#d0ebff',
      };
    } else if (data.colorSchema === 'yellow') {
      return {
        bg: '#fff3bf',
      };
    } else if (data.colorSchema === 'gray') {
      return {
        bg: '#e9ecef',
      };
    }
  }, [data]);

  return (
    <Box
      width="100%"
      bg={color.bg}
      border="1px solid"
      borderColor="rgba(0,0,0, .3)"
      borderRadius="md"
      p={6}
      my={4}
    >
      {data.title && (
        <Box fontSize="lg" fontWeight="bold" mb={2}>
          {data.title}
        </Box>
      )}
      <HTMLText text={data.text} />
    </Box>
  );
};

export default InfoBox;
